import React from 'react'

const Spinner = () =>
    <div className="loader-wrapper">
        <div className="loader"></div>
    </div>;

export default Spinner;